import React from 'react';
import { Provider } from 'react-redux';
import store from './store';
import Router from '../router';
import GlobalStyles from './global';
function App() {
    return (React.createElement(Provider, { store: store },
        React.createElement(GlobalStyles, null),
        React.createElement(Router, null)));
}
export default App;
